import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/core';
import { PathConfig } from 'src/app/core/config/path.config';
import { environment } from 'src/environments/environment';
import { TakePaymentComponent } from '../take-payment/take-payment.component';
@Component({
  selector: 'app-take-pmt',
  templateUrl: './take-pmt.component.html',
  styleUrls: ['./take-pmt.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TakePmtComponent implements OnInit {
  environment = environment;
  @Input() loanDetail!: any;
  @Input() loanID!: any;
  @Input() id!: any;
  @Input() editMode!: boolean;
  @Input() transactionDetails!: any;
  @Input() previousTransaction!: any;
  @Input() take_payment_url: string = '';
  activePaymentPortals: any[] = [];
  @Input() standardSettingsData: any;
  @Input() clientDetailService: any;


  constructor(
    private modalService: NgbModal,
    public modal: NgbActiveModal,
    private httpService: HttpService, private translateService: TranslateService
  ) {
    this.translateService.setDefaultLang('en');
    this.translateService.use(localStorage.getItem('Selected_Language') || 'en');

  }

  ngOnInit(): void {
    this.getActivePaymentPortalList();
  }

  getActivePaymentPortalList() {
    const url = `${PathConfig.PAYMENT_PORTALS}`;
    this.httpService.get(url).subscribe(
      (Response) => {
        this.activePaymentPortals = Response;
      }
    );
  }

  openTakePaymentModal(content: any) {
    const url = `${PathConfig.LOAN_PREVIOUS_TRANSACTION}?loan_id=${this.loanID}`;
    this.httpService.get(url).subscribe((res) => {
      this.modalService.dismissAll();
      this.previousTransaction = res;
      const modalRef = this.modalService.open(TakePaymentComponent, {
        centered: true,
        size: 'xl',
        windowClass: 'draggable-container',
        backdrop: false,
      });
      modalRef.componentInstance.previousTransaction = this.previousTransaction;
      modalRef.componentInstance.loanDetail = this.loanDetail;
      modalRef.componentInstance.loanID = this.loanID;
      modalRef.componentInstance.standardSettingsData = this.standardSettingsData;
      modalRef.componentInstance.clientDetailService = this.clientDetailService;
    })
  }
  handlePaynearmeClick(portal: any) {
    this.authenticateAgent().subscribe(
      (response: any) => {
        this.modal.dismiss('Cross click');
        if (response && response.url) {
          // Open the new URL if it's provided
          window.open(response.url, '_blank');
        } else {
          // If no URL returned, fall back to the existing URL
          if (portal.payment_portal_url) {
            window.open(portal.payment_portal_url, '_blank');
          }
        }
      },
      (error) => {
        this.modal.dismiss('Cross click');
        // Fallback: Open the existing payment portal URL in case of failure
        if (portal.payment_portal_url) {
          window.open(portal.payment_portal_url, '_blank');
        }
      }
    );
  }

  authenticateAgent(): Observable<any> {
    const url = `${PathConfig.AUTHENTICATE_AGENT}`;
    const param = {
      loan_id: this.loanID
    };
    return this.httpService.post(url, param);
  }

}
